/**
 * NoteWidget — notatka rich-text. Treść (HTML z TipTap) siedzi w
 * `config.html`; edycja przez WidgetConfigModal (tryb edycji). Bez backendu.
 *
 * Renderujemy zapisany HTML usera w jego własnym pulpicie (tenant-scope, dziś
 * widoczne tylko dla autora). HTML sanityzujemy DOMPurify przed wstrzyknięciem —
 * nie ufamy „to tylko autor", bo pulpity mogą kiedyś być współdzielone.
 */

import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

import type { WidgetRenderProps } from '../types';

export function NoteWidget({ widget }: WidgetRenderProps) {
  const { t } = useTranslation();
  if (widget.type !== 'note') return null;

  const html = widget.config.html?.trim();
  if (!html) {
    return (
      <p className="flex h-full items-center justify-center text-sm text-text-tertiary">
        {t('tenant.dashboard.widgets.note.empty')}
      </p>
    );
  }

  return (
    <div
      className="prose prose-sm max-w-none text-sm text-text-primary"
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
    />
  );
}
